export default function EntryForm({
  draft,
  onDraftChange,
  onSaveEntry,
  typeOrder,
  typeStyles,
  statusOptions,
  extraFields,
  titlePlaceholders,
  formCardStyle,
  typeButtonsStyle,
  typeButtonStyle,
  inputStyle,
  formRowStyle,
  saveButtonStyle,
}) {
  return (
    <div style={formCardStyle}>
      <div style={typeButtonsStyle}>
        {typeOrder.map((type) => (
          <button
            key={type}
            onClick={() => onDraftChange("type", type)}
            style={{
              ...typeButtonStyle,
              borderColor:
                draft.type === type ? typeStyles[type].color : "#EFE9E1",
              background:
                draft.type === type ? typeStyles[type].bg : "transparent",
              color: draft.type === type ? typeStyles[type].color : "#8A8178",
            }}
          >
            {typeStyles[type].label}
          </button>
        ))}
      </div>

      <input
        placeholder={titlePlaceholders[draft.type]}
        value={draft.title}
        onChange={(event) => onDraftChange("title", event.target.value)}
        style={inputStyle}
      />

      {extraFields[draft.type].map((field) => (
        <input
          key={field.name}
          placeholder={field.placeholder}
          value={draft[field.name]}
          onChange={(event) => onDraftChange(field.name, event.target.value)}
          style={{ ...inputStyle, marginTop: 8 }}
        />
      ))}

      <div style={formRowStyle}>
        <select
          value={draft.status}
          onChange={(event) => onDraftChange("status", event.target.value)}
          style={{ ...inputStyle, flex: 1 }}
        >
          {statusOptions[draft.type].map((status) => (
            <option key={status.label} value={status.label}>
              {status.emoji} {status.label}
            </option>
          ))}
        </select>

        <select
          value={draft.rating}
          onChange={(event) =>
            onDraftChange("rating", Number(event.target.value))
          }
          style={{ ...inputStyle, width: 90 }}
        >
          {[5, 4, 3, 2, 1].map((rating) => (
            <option key={rating} value={rating}>
              {rating} ★
            </option>
          ))}
        </select>
      </div>

      <input
        placeholder="Tags (comma separated)"
        value={draft.tags}
        onChange={(event) => onDraftChange("tags", event.target.value)}
        style={{ ...inputStyle, marginTop: 8 }}
      />

      <input
        placeholder="Note (optional)"
        value={draft.note}
        onChange={(event) => onDraftChange("note", event.target.value)}
        style={{ ...inputStyle, marginTop: 8 }}
      />

      <button onClick={onSaveEntry} style={saveButtonStyle}>
        Save entry
      </button>
    </div>
  );
}
